import { getCoveredIndividuals } from "."

export default function getDefaultInsurance(plan, individuals) {
	const reimbursementMethod = plan?.employerPlan?.reimbursementDistributionMethod
	
	// Ensure individuals is an array to prevent spread errors
	const safeIndividuals = individuals || []
	
	return {
		insuranceId: "",
		insuranceCoverage: "",
		coverageSource: "",
		provider: {},
		policyHolder: "",
		insuranceProof: null,
		coveredIndividuals: getCoveredIndividuals(plan, null, safeIndividuals),
		isComplete: false,
		...(reimbursementMethod === "CHECK" ? { policyId: "" } : {})
	}
}